import { useEffect, useState } from 'react';

/**
 * Custom hook for debouncing the update of a value
 * @param {any} value - value to debounce
 * @param {number} delay - the time after the hook returns the new value if value didn't change
 */
export default function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return debouncedValue;
}
